(function () {
    const loginIntro = $('.login-intro-container');
    const loginForm = $('.login-form-container');
    const loginPopup = $('.login-popup');

    if (loginIntro.length) {
        const loginFormToggler = loginIntro.find('.intro-link');
        loginFormToggler.on('click', function (e) {
            if (!e.target.href || !e.target.href.length || e.target.href.replace(location.href, '') === '#') {
                e.preventDefault();
                loginForm.removeClass('hidden');
                loginIntro.addClass('hidden');
            }
        });
        if (!$('.login-popup').hasClass('hidden') && $('.login-form').find('.message.error').length > 0) {
            loginForm.removeClass('hidden');
            loginIntro.addClass('hidden');
        }
        const loginPopupCloseBtn = loginPopup.find('.close');
        loginPopupCloseBtn.on('click', function () {
            loginForm.addClass('hidden');
            loginIntro.removeClass('hidden');
        });

        $('body').on('blur focusout', '.login-popup a:visible:last', function (e) {
            loginPopup.find('.close').focus();
        });
        $('body').on('click', '.loginBar .show-login', function (e) {
            loginIntro.removeClass('hidden');
            setTimeout(function () {
                loginPopup.find('.close').focus();
            }, 250);
        });
    }
})();
